module.exports = __webpack_public_path__ + "img/LeftAndRightFixedE.d23a6a3b.png";